import { I as C, $ as S, x as O } from "./PlaygroundNodes-B1J2GgG-.js";
import { O as oe, y as le, P as ie, j as ne } from "./PlaygroundNodes-B1J2GgG-.js";
import { CHECK_LIST as h, ELEMENT_TRANSFORMERS as M, TEXT_FORMAT_TRANSFORMERS as b, TEXT_MATCH_TRANSFORMERS as x, $convertToMarkdownString as A, $convertFromMarkdownString as I } from "@lexical/markdown";
import { HorizontalRuleNode as $, $createHorizontalRuleNode as D, $isHorizontalRuleNode as L } from "@lexical/react/LexicalHorizontalRuleNode";
import { TableNode as w, TableRowNode as v, TableCellNode as P, $isTableNode as _, $isTableRowNode as T, $isTableCellNode as N, TableCellHeaderStates as E, $createTableNode as y, $createTableRowNode as z, $createTableCellNode as H } from "@lexical/table";
import { $isParagraphNode as U, $isTextNode as F, $createTextNode as K } from "lexical";
import j from "./emoji-list-CKk-PE96.js";
import { s as ae, v as ce } from "./url-CGtSDuPu.js";
import { D as pe, I as _e, S as Te, a as Ee, U as ue } from "./index-DKx_Eaeq.js";
const k = {
  dependencies: [$],
  export: (e) => L(e) ? "***" : null,
  regExp: /^(---|\*\*\*|___)\s?$/,
  replace: (e, t, r, o) => {
    const i = D();
    o || e.getNextSibling() != null ? e.replace(i) : e.insertBefore(i), i.selectNext();
  },
  type: "element"
}, G = {
  dependencies: [C],
  export: (e) => O(e) ? `![${e.getAltText()}](${e.getSrc()})` : null,
  importRegExp: /!(?:\[([^[]*)\])(?:\(([^(]+)\))/,
  regExp: /!(?:\[([^[]*)\])(?:\(([^(]+)\))$/,
  replace: (e, t) => {
    const [, r, o] = t, i = S({
      altText: r,
      maxWidth: 800,
      src: o
    });
    e.replace(i);
  },
  trigger: ")",
  type: "text-match"
}, W = {
  dependencies: [],
  export: () => null,
  importRegExp: /:([a-z0-9_]+):/,
  regExp: /:([a-z0-9_]+):/,
  replace: (e, [, t]) => {
    const r = j.find((o) => o.aliases.includes(t))?.emoji;
    r && e.replace(K(r));
  },
  trigger: ":",
  type: "text-match"
}, f = /^(?:\|)(.+)(?:\|)\s?$/, B = /^(\| ?:?-*:? ?)+\|\s?$/, X = {
  dependencies: [w, v, P],
  export: (e) => {
    if (!_(e))
      return null;
    const t = [];
    for (const r of e.getChildren()) {
      const o = [];
      if (!T(r))
        continue;
      let i = !1;
      for (const l of r.getChildren())
        N(l) && (o.push(
          A(R, l).replace(
            /\n/g,
            "\\n"
          )
        ), l.__headerState === E.ROW && (i = !0));
      t.push(`| ${o.join(" | ")} |`), i && t.push(`| ${o.map((l) => "---").join(" | ")} |`);
    }
    return t.join(`
`);
  },
  regExp: f,
  replace: (e, t, r) => {
    if (B.test(r[0])) {
      const s = e.getPreviousSibling();
      if (!s || !_(s))
        return;
      const a = s.getChildren(), n = a[a.length - 1];
      if (!n || !T(n))
        return;
      n.getChildren().forEach((u) => {
        N(u) && u.toggleHeaderStyle(E.ROW);
      }), e.remove();
      return;
    }
    const o = d(r[0]);
    if (o == null)
      return;
    const i = [o];
    let l = e.getPreviousSibling(), c = o.length;
    for (; l && !(!U(l) || l.getChildrenSize() !== 1); ) {
      const s = l.getFirstChild();
      if (!F(s))
        break;
      const a = d(s.getTextContent());
      if (a == null)
        break;
      c = Math.max(c, a.length), i.unshift(a);
      const n = l.getPreviousSibling();
      l.remove(), l = n;
    }
    const g = y();
    for (const s of i) {
      const a = z();
      g.append(a);
      for (let n = 0; n < c; n++)
        a.append(n < s.length ? s[n] : m(""));
    }
    const p = e.getPreviousSibling();
    _(p) && J(p) === c ? (p.append(...g.getChildren()), e.remove()) : e.replace(g), g.selectEnd();
  },
  type: "element"
};
function J(e) {
  const t = e.getFirstChild();
  return T(t) ? t.getChildrenSize() : 0;
}
const m = (e) => {
  e = e.replace(/\\n/g, `
`);
  const t = H(E.NO_STATUS);
  return I(e, R, t), t;
}, d = (e) => {
  const t = e.match(f);
  return !t || !t[1] ? null : t[1].split("|").map((r) => m(r));
}, R = [
  X,
  k,
  G,
  W,
  h,
  ...M,
  ...b,
  ...x
];
export {
  pe as DELETE_DOCUMENT_LINK_COMMAND,
  _e as INSERT_DOCUMENT_LINK_COMMAND,
  oe as OPEN_CARD_LINK_DIALOG_COMMAND,
  le as OPEN_DECISION_TREE_LINK_DIALOG_COMMAND,
  R as PLAYGROUND_TRANSFORMERS,
  ie as PlaygroundNodes,
  Te as SET_CARD_LINK_COMMAND,
  Ee as SET_DECISION_TREE_LINK_COMMAND,
  ue as UPDATE_DOCUMENT_LINK_COMMAND,
  ne as computeWysiwygSearchState,
  ae as sanitizeUrl,
  ce as validateUrl
};
//# sourceMappingURL=wysiwyg-kit.js.map
